import React, { useState, useMemo, memo } from "react";
import { withRouter } from "react-router-dom";
import Slider from "react-slick";

import {
  Dialog,
  DialogContent,
  IconButton,
  Slide,
  Typography,
  makeStyles,
  useTheme,
} from "@material-ui/core";
import { withNamespaces } from "react-i18next";
import Tooltip from "@material-ui/core/Tooltip";
import CloseIcon from "@material-ui/icons/Close";

import { ReactComponent as CheckMarkIconSvg } from "../../../assets/certified.svg";

const useStyles = makeStyles((theme) => ({
  paper: {
    backgroundColor: "rgba(0,0,0,0.7)",
    boxShadow: "none",
    padding: "0px",
    margin: "0px",
  },
  modalContent: {
    position: "relative",
    width: "100%",
    display: "flex",
    alignItems: "end",
    flexDirection: "column",
    justifyContent: "center",
    margin: "auto",
    height: "100%",

    [theme.breakpoints.up("sm")]: {
      width: "50%",
    },
  },
  modalCloseIcon: {
    // width: "28px",
    // height: "28px",
    display: "block",

    color: theme?.colors?.presale?.cardTitle,
    cursor: "pointer",
    "&:hover": {
      opacity: 0.8,
    },

    // top: "15rem",
    // right: "25px",

    // [theme.breakpoints.up("sm")]: {
    //   top: "20rem",
    //   right: "6.5rem",
    // },
  },
  poolInfoCard: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",
  },
  poolMainInfo: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    flexDirection: "column",
    [theme.breakpoints.up("sm")]: {
      justifyContent: "space-between",
    },
  },
  poolTitleAddressContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    marginBottom: "16px",

    [theme.breakpoints.up("sm")]: {
      flexDirection: "row",
    },
  },
  tooltip: {
    fontSize: "16px",
  },
  checkMarkIcon: {
    marginLeft: "8px",
    width: "25px",
    height: "25px",

    color: theme?.colors.poolCard?.linkIcon,
  },
  carrouselImgs: {
    objectFit: "cover",
    borderRadius: "20px",

    width: "100%",
    padding: "0 6px",
    margin: "0 auto",

    [theme.breakpoints.up("sm")]: {
      width: "unset",
      boxShadow: "0px 0px 10px " + theme?.colors?.containerShadow,
      padding: "0",
    },
  },
  mainImage: {
    width: "100%",
    objectFit: "contain",
    borderRadius: "20px",
  },
  slickDots: {
    "& li button:before": {
      fontFamily: "slick",
      fontSize: "6px",
      position: "absolute",
      top: 0,
      left: 0,
      width: "16px",
      height: "16px",
      content: "",
      textAlign: "center",
      opacity: 0.25,
      color: "#A0A0A0",
      WebkitFontSmoothing: "antialiased",
      MozOsxFontSmoothing: "grayscale",
      background: "#A0A0A0", // Default dot background
      borderRadius: "50%", // Make it circular
    },
    "& li.slick-active button:before": {
      background: "#1F6FFF",
      color: "#1F6FFF",
      opacity: 1,
    },
    "& .slick-prev:before": {
      content: "",
      display: "none",
    },
    "& .slick-next:before": {
      content: "",
      display: "none",
    },
  },
  poolImage: {
    width: "90px",
    height: "90px",
    marginRight: "8px",
    borderRadius: "50%",
    [theme.breakpoints.up("sm")]: {
      marginRight: "16px",
    },
  },
  poolTitleAddress: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "space-between",
    marginBottom: "18px",
    [theme.breakpoints.up("sm")]: {
      marginBottom: "32px",
    },
  },

  saleTitleStyle: {
    margin: "0px",

    color: theme?.colors?.presale?.cardTitle,
    fontSize: "20px",
    fontWeight: "bold",
    lineHeight: "24px",

    [theme.breakpoints.up("sm")]: {
      fontSize: "30px",
      lineHeight: "36px",
    },
  },
  poolTitle: {
    color: theme?.colors?.presale?.cardTitle,
    fontSize: "20px",
    fontWeight: "bold",
    lineHeight: "24px",
    display: "flex",
    alignItems: "center",

    marginTop: "8px",

    [theme.breakpoints.up("sm")]: {
      marginTop: "0px",
      fontSize: "30px",
      lineHeight: "36px",
    },
    position: "relative",
  },
  poolDescription: {
    color: theme?.colors?.presale?.cardText,
    fontSize: "15px",
    fontWeight: "normal",
    lineHeight: "18px",
    marginBottom: "8px",
  },

  poolTokenLabel: {
    color: theme?.colors?.presale?.cardTitleSecondary,
    fontSize: "15px",
    fontWeight: "normal",
    lineHeight: "18px",
    marginBottom: "8px",
  },

  tokenAddressTitle: {
    fontWeight: 600,
    color: theme?.colors?.presale?.cardText,
    fontSize: "15px",
    lineHeight: "18px",
    marginBottom: "8px",
    lineBreak: "anywhere",
  },
  poolTokenAddress: {
    color: theme?.colors?.presale?.addressValueText,
    fontSize: "12px",
    fontWeight: 600,
    [theme.breakpoints.up("sm")]: {
      fontSize: "15px",
    },
  },
  poolStatusContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.up("ms")]: {
      alignItems: "flex-end",
      justifyContent: "flex-end",
      minWidth: "250px",
    },
  },
  poolStatusBox: {
    minWidth: "140px",
    width: "fit-content",
    paddingLeft: "8px",
    paddingRight: "8px",
    height: "32px",
    borderRadius: "24px",
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme?.colors.poolCard?.poolTypeText,
    whiteSpace: "nowrap",
  },
  poolListingInfo: {
    marginTop: "25px",
    color: theme?.colors?.presale?.cardTitleSecondary,
    fontSize: "15px",
    fontWeight: "normal",
    lineHeight: "18px",
  },
  poolStatusInfo: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    marginBottom: "15px",
    [theme.breakpoints.up("sm")]: {
      marginBottom: "30px",
    },
  },
  poolSaleText: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    [theme.breakpoints.up("sm")]: {
      alignItems: "flex-start",
      justifyContent: "flex-start",
    },
  },
  poolSaleHeader: {
    color: theme?.colors?.presale?.cardTitleSecondary,
    fontSize: "15px",
    fontWeight: "normal",
    lineHeight: "18px",
    marginBottom: "8px",
  },
  poolSaleValue: {
    color: theme?.colors?.presale?.addressValueText,
    fontSize: "25px",
    fontWeight: "normal",
    lineHeight: "30px",
  },
  poolFilledBox: {
    height: "12px",
    width: "100%",
    backgroundColor: theme?.colors?.presale?.addressValueText + " !important",
    borderRadius: "12px",
    position: "absolute",
    left: "0px",
    top: "0px",
    [theme.breakpoints.up("sm")]: {
      height: "16px",
    },
  },
  poolPercentageInfo: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "space-between",
  },
  poolPercentageText: {
    color: theme?.colors?.presale?.cardTitleSecondary,
    fontSize: "15px",
    fontWeight: "normal",
    lineHeight: "18px",
  },
  poolSubInfoSecondaryContainer: {
    display: "grid",
    width: "100%",
    gridGap: "15px",
    gridTemplateColumns: "1fr 1fr",
    [theme.breakpoints.up("sm")]: {
      gridTemplateColumns: "1fr 1fr",
      gridGap: "20px",
    },
    [theme.breakpoints.up("ms")]: {
      gridTemplateColumns: "1fr 1fr 1fr",
      gridGap: "25px",
    },
    [theme.breakpoints.up("md")]: {
      gridTemplateColumns: "1fr 1fr 1fr 1fr",
      gridGap: "30px",
    },
  },
  poolSubInfoContainer: {
    display: "grid",
    width: "100%",
    gridGap: "15px",
    gridTemplateColumns: "1fr 1fr",
    [theme.breakpoints.up("sm")]: {
      gridTemplateColumns: "1fr 1fr",
      gridGap: "20px",
    },
    [theme.breakpoints.up("ms")]: {
      gridTemplateColumns: "1fr 1fr 1fr",
      gridGap: "25px",
    },
    [theme.breakpoints.up("md")]: {
      gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr",
      gridGap: "30px",
    },
  },

  poolSubInfoV3Container: {
    display: "grid",
    width: "100%",
    gridGap: "15px",
    gridTemplateColumns: "1fr 1fr",
    [theme.breakpoints.up("sm")]: {
      gridTemplateColumns: "1fr 1fr",
      gridGap: "20px",
    },
    [theme.breakpoints.up("ms")]: {
      gridTemplateColumns: "1fr 1fr 1fr",
      gridGap: "25px",
    },
    [theme.breakpoints.up("md")]: {
      gridTemplateColumns: "1fr 1fr 1fr 1fr",
      gridGap: "30px",
    },
  },
  poolSubInfoCard: {
    display: "flex",
    flexDirection: "column",
  },
  poolSubInfoHeading: {
    color: theme?.colors?.presale?.cardTitleSecondary,
    fontSize: "15px",
    fontWeight: "normal",
    lineHeight: "18px",
    marginBottom: "4px",
    [theme.breakpoints.up("sm")]: {
      marginBottom: "8px",
    },
  },
  poolSubInfoValue: {
    color: theme?.colors?.presale?.addressValueText,
    fontSize: "20px",
    fontWeight: "normal",
    lineHeight: "24px",
  },
  link: {
    textDecoration: "none",
    "&:hover": {
      opacity: 0.8,
    },
  },
  badge: {
    width: "30px",
    height: "30px",
    marginLeft: "6px",
    [theme.breakpoints.up("sm")]: {
      marginLeft: "4px",
    },
  },
}));

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

function CarouselNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        position: "absolute",
        width: "30px",

        right: "10px",
        zIndex: 5,
      }}
      onClick={onClick}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth="1.5"
        stroke="#8b8b8b"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m8.25 4.5 7.5 7.5-7.5 7.5"
        />
      </svg>
    </div>
  );
}

function CarouselPrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        position: "absolute",
        width: "30px",
        left: "10px",
        zIndex: 5,
      }}
      onClick={onClick}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth="1.5"
        onClick={onClick}
        stroke="#8b8b8b"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M15.75 19.5 8.25 12l7.5-7.5"
        />
      </svg>
    </div>
  );
}

function ImagesContainer({
  classes,
  onExpandImage,
  carouselImgs,
  size = "sm",
}) {
  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: false,
    nextArrow: <CarouselNextArrow />,
    prevArrow: <CarouselPrevArrow />,
    draggable: false,
  };

  return (
    <>
      {carouselImgs.length === 1 ? (
        <img
          onClick={() => {
            if (onExpandImage) onExpandImage();
          }}
          style={{
            // height: onExpandImage ? "unset" : "22rem",
            cursor: onExpandImage ? "pointer" : "",
          }}
          className={classes.mainImage}
          src={carouselImgs[0]}
          alt="Placeholder Img"
        />
      ) : (
        <div style={{ width: "100%" }}>
          <Slider {...settings} className={classes.slickDots}>
            {carouselImgs.map((img, index) => (
              <div>
                <img
                  onClick={() => {
                    if (onExpandImage) onExpandImage();
                  }}
                  key={index}
                  style={{
                    height: size === "sm" ? "15rem" : "20rem",
                    cursor: onExpandImage ? "pointer" : "",
                  }}
                  className={classes.carrouselImgs}
                  src={img}
                  alt={`Carousel Img ${index}`}
                />
              </div>
            ))}
          </Slider>
        </div>
      )}
    </>
  );
}

function ExpandedImageView({ modalOpen, closeModal, classes, carouselImgs }) {
  return (
    <Dialog
      open={modalOpen}
      onClose={closeModal}
      fullWidth={true}
      fullScreen={true}
      TransitionComponent={Transition}
      classes={{ paper: classes.paper, paperWidthSm: classes.modalRoot }}
    >
      <DialogContent classes={{ root: classes.modalContent }}>
        <IconButton
          aria-label="close"
          className={classes.modalCloseIcon}
          onClick={closeModal}
        >
          <CloseIcon />
        </IconButton>
        <ImagesContainer
          size="lg"
          classes={classes}
          carouselImgs={carouselImgs}
        />
      </DialogContent>
    </Dialog>
  );
}

const MainInfoCard = ({ poolInfo }) => {
  const classes = useStyles();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const initialPoolInfo = useMemo(() => poolInfo, []);

  const [logoImage, setLogoImage] = useState(
    initialPoolInfo?.linkLogo || "pools/default.png"
  );
  const theme = useTheme();

  const [showExpandedImages, setShowExpandedImages] = useState(false);

  const carouselImgs = useMemo(() => {
    const imgs = [];
    if (initialPoolInfo?.linkImgMain) {
      imgs.push(initialPoolInfo?.linkImgMain);
    }
    if (initialPoolInfo?.linkImgAlt1) {
      imgs.push(initialPoolInfo?.linkImgAlt1);
    }
    if (initialPoolInfo?.linkImgAlt2) {
      imgs.push(initialPoolInfo?.linkImgAlt2);
    }

    return imgs;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialPoolInfo]);

  return (
    <div className={classes.poolInfoCard}>
      <div className={classes.poolMainInfo}>
        <div className={classes.poolTitleAddressContainer}>
          <img
            className={classes.poolImage}
            src={logoImage}
            alt="pool"
            onError={(er) => {
              setLogoImage("pools/default.png");
            }}
          />
          <Typography variant="h1" className={classes.poolTitle}>
            <p className={classes.saleTitleStyle}>
              {initialPoolInfo?.saleTitle || "..."}
              <span>
                {initialPoolInfo?.certified && (
                  <Tooltip
                    title="Certified BUIDLer"
                    classes={{ tooltip: classes.tooltip }}
                  >
                    <CheckMarkIconSvg className={classes.checkMarkIcon} />
                  </Tooltip>
                )}
              </span>
            </p>
          </Typography>
        </div>

        <div>
          <div className={classes.poolTitleAddress}>
            <Typography variant="h2" className={classes.tokenAddressTitle}>
              Token Address
            </Typography>
            <a
              className={classes.link}
              href={
                theme?.blockExplorer +
                "address/" +
                initialPoolInfo?.tokenAddress
              }
              target="_blank"
              rel="noopener noreferrer"
            >
              <Typography variant="h5" className={classes.poolTokenAddress}>
                {initialPoolInfo?.tokenAddress}
              </Typography>
            </a>
          </div>
        </div>

        <ImagesContainer
          onExpandImage={() => setShowExpandedImages(true)}
          classes={classes}
          carouselImgs={carouselImgs}
        />
        <ExpandedImageView
          classes={classes}
          carouselImgs={carouselImgs}
          modalOpen={showExpandedImages}
          closeModal={() => setShowExpandedImages(false)}
        />
      </div>
    </div>
  );
};

function customAreEqual(prevProps, nextProps) {
  return true; // Simplistic example, always skips re-rendering
}

export default withNamespaces()(withRouter(memo(MainInfoCard, customAreEqual)));
